import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow, SectionCta } from "./Reveal";

export const Founder = () => {
  const imgRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: imgRef,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-7%", "7%"]);

  return (
    <section id="founder" data-testid="founder-section" className="py-24 md:py-36 bg-coal border-y border-black/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative clipped-frame overflow-hidden shadow-[0_24px_60px_rgba(14,20,27,0.12)]" ref={imgRef}>
            <motion.img
              src="/founder.jpg"
              alt="Jumi Adeyinka, founder of North & Noble"
              className="w-full h-[560px] object-cover object-top"
              style={{ y: imgY, scale: 1.15 }}
              loading="lazy"
              decoding="async"
              data-testid="founder-portrait"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6">
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-champagne">Founder</p>
              <p className="mt-1 font-display text-2xl text-pearl">Jumi Adeyinka</p>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>Why this exists</Eyebrow>
            <h2 className="font-display font-light tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-pearl">
              I am not selling you a theory. <span className="italic text-champagne">I run this in my own practice.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-base md:text-lg text-zinc-600 leading-relaxed max-w-2xl">
              I am a medical professional and I own a med spa here in Houston. I built The
              Back-Office Engine inside my own practice first, on my own patients, my own phones and
              my own money. I was the one losing inquiries, chasing follow-ups and retraining admin
              staff between appointments.
            </p>
            <p className="mt-5 text-base md:text-lg text-zinc-600 leading-relaxed max-w-2xl">
              Hire, train, hope, lose the person, rebuild. I ran that loop for years before I
              admitted it would never fix itself. So I stopped hiring for the problem and built a
              system for it. Then I proved it on my own practice before I offered it to another
              owner.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <blockquote className="mt-10 border-l-2 border-champagne pl-8 max-w-2xl">
              <p className="font-display italic text-2xl md:text-3xl text-champagne leading-snug">
                "That is not a people problem. That is a back-office infrastructure problem."
              </p>
              <footer className="mt-4 font-mono text-xs tracking-widest uppercase text-zinc-500">
                Jumi Adeyinka · Founder, North &amp; Noble
              </footer>
            </blockquote>
          </Reveal>
          <Reveal delay={0.35}>
            <p className="mt-8 font-mono text-xs tracking-widest uppercase text-zinc-500">
              Licensed medical professional · Med spa owner-operator · Houston, TX
            </p>
          </Reveal>
          <SectionCta id="founder" label="Talk to Jumi directly" />
        </div>
      </div>
    </section>
  );
};
